/**
 * Post-signup intent: what to do after signup completes.
 * Missing / null => default to 'benefits' (redirect to /member/benefits).
 * Set before opening signup when the user was interrupted from an action.
 *
 * Shape: { onSuccess: 'benefits' | 'close' | 'navigate' | 'reload', url?: string, ctx?: string, returnUrl?: string }
 * ctx: optional context for analytics (e.g. 'daily-number', 'daily-hexagram',
 * 'daily-tarot-card', 'weekly-tarot-card', 'compatibility-chooser')
 * returnUrl: when onSuccess is 'benefits' and user completes long (4-step) signup flow,
 * pass to /member/benefits?return_url= so signup-return-modal can offer "return to what you were doing"
 * - benefits: redirect to /member/benefits (default when intent is missing)
 * - close: close modal only (e.g. in-product / product.pending flow)
 * - navigate: redirect to intent.url (e.g. compat report)
 * - reload: reload current page (e.g. daily number to show personalized content)
 */
export const initial = null;

export const set = (state, payload) => payload;

export const clear = () => null;
